module.exports = __webpack_public_path__ + "static/media/dni-tramite.b412b9c2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/agsm/img/dni-tramite.png
 ** module id = 1662
 ** module chunks = 0
 **/